import axios from 'axios'
import qs from 'qs'
import store from '@/store'
import { getToken } from '@/libs/cookie-storage'
import isEmpty from 'lodash/isEmpty'
import {varConfig} from '@/utils'
import router from '@/router'
import { Toast } from 'vant'
import Vue from 'vue'
Vue.use(Toast)

// 创建axios实例
const service = axios.create({
  baseURL: varConfig.banmaApi, // api的base_url
  // baseURL: 'http://139.196.223.220:8090/',
  timeout: 50000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(config => {
  if (config.data) {
    config.data = qs.stringify(config.data)
  }
  config.params = config.params || {}
  const token = getToken()
  if (token) {
    config.params.passport = getToken()
  }
  // get method, params object to url query string
  // avoid param value contains url bug
  config.url += isEmpty(config.params) ? '' : ('?' + qs.stringify(config.params))
  config.params = null
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
  /**
  * code为非20000是抛错 可结合自己业务进行修改
  */
    const res = response.data
    if (res.error) {
      const error = res.messages.error
      let message = ''
      if (error.code === 'login_required' || error.code === 'login_account_expired' || error.code === 'login_account_denied') {
        store.dispatch('LogOut').then(() => {
          // location.reload()// 为了重新实例化vue-router对象 避免bug
          router.push({name: 'Login'})
        })
        message = error.message
      } else {
        if (res.code === 500 && error.code === 'internal_error') {
          message = '内部错误：' + error.message
        } else {
          message = error.message
          Toast(message)
        }
      }
      // console.log(message)
      return Promise.resolve(false)
    } else {
      return res.messages
    }
  },
  error => {
    Toast(error.message)
    // console.log(error.message)// for debug
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js